import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { extend } from 'jquery';

// INNER IMPORTS
import '../mainAdminstyles.css';
import { convertArrayOfObjectsToCSV } from '../../../../utils';

import { SimpleDatePicker } from '../../../Elements/Pickers';
import { ButtonSimple } from '../../../Elements/Buttons';
import FaCehck from 'react-icons/lib/fa/check';
import FaClose from 'react-icons/lib/fa/close';
import FaBeUser from 'react-icons/lib/fa/user-secret';
import FaErrowDown from 'react-icons/lib/fa/angle-down';
import FaErrowUp from 'react-icons/lib/fa/angle-up';
import {
    getAllUsers,
    deactivate,
    activate,
    beUser,
    createTempUserCall,
    toggleAnalyticsDisable,
    toggleUnlimitedPins
} from "../../../../Actions/admin";

const initialTempUser = {
    tempUserEmail: 'changethis@mugics.com',
    tempUserPassword: '12345678',
    tempUserNickname: 'temp user'
};

class AdminUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "liveMusic",
            isTempUser: false,
            userEmail: '',
            isOnlyTmpUsers: false,
            ...initialTempUser
        };
    }

    componentDidMount() {
        this.props.getAllUsers(this.props.token, {});
        //this.setState({users: this.props.users});
    }

    downloadCSV() {
        let data, filename, link;

        let users = extend(true, {}, this.props.users);

        // using lodash to prevent pass to 'users' a value and not a reference for the array AND the objects in it
        // users = filter(users, (user) => {
        //     return this.state.userSearch ? user.local.email.includes(this.state.userSearch) : true;
        // });

        users.forEach((user)=> {
            if (user.local) {
                user.username = user.local.email;
                user.local = true;
                user.google = false;
                user.facebook = false;
            }
            else if (user.google) {
                user.username = user.google.name;
                user.local = false;
                user.google = true;
                user.facebook = false;
            }
            else if (user.facebook) {
                user.username = user.facebook.name;
                user.local = false;
                user.google = false;
                user.facebook = true;
            }

            user.lastLogin = moment(user.lastLogin).format('DD.MM.YY');
            user.isVerified = user.activation.isVerified || false;
            if (user.pinsCount) {
                user.pinsCountFree = user.pinsCount.free;
                user.pinsCountMid = user.pinsCount.mid;
                user.pinsCountHigh = user.pinsCount.high;
                user.pinsCountHuge = user.pinsCount.huge;

                delete user.pinsCount;
            }


            delete user.activation;
            delete user._id;
            delete user.local;
        });

        let csv = convertArrayOfObjectsToCSV({
            data: users
        });

        if (csv === null) return;

        filename = 'users.csv';

        const csvFinal = 'data:text/csv;charset=utf-8,' + csv.replace('data:text/csv;', '');

        // if (!csv.match(/^data:text\/csv/i)) {
        //     csv = 'data:text/csv;charset=utf-8,' + csv;
        // }

        data = encodeURI(csvFinal);

        link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        link.click();
    }

    addTempUser() {
        if (this.state.isTempUser) return;

        // TODO: gen random user email - probably should check width server what temp users exsited???
        this.setState({ isTempUser: true});
    }

    setUserEmail(event){
        if (!event) return;
        this.setState({ userEmail: event.target.value });
    }

    dateHandler(startDate, endDate) {
        this.setState({
            startDate,
            endDate
        });
    }

    toggleOnlyTmpUsers() {
        this.setState({ isOnlyTmpUsers: !this.state.isOnlyTmpUsers })
    }

    resetDates() {
        this.setState({startDate: '', endDate: '', sortType: ''});
    }

    handleSearchClick() {
        this.props.getAllUsers(this.props.token, this.state);
    }

    beUserhandler(user) {
        if (!window.confirm('Are you sure you want to be user: ' + user.local.email)) return;
        this.props.beUser(this.props.token, user._id)
    }

    deactivateUser(user) {
        if (!window.confirm('Are you sure you want to deactivate this user: ' + user.local.email)) return;

        this.props.deactivate(this.props.token, user._id).then(()=> {
            this.props.getAllUsers(this.props.token, this.state);
        })
    }

    activateUser(user) {
        if (!window.confirm('Are you sure you want to activate this user: ' + user.local.email)) return;

        this.props.activate(this.props.token, user._id).then(()=> {
            this.props.getAllUsers(this.props.token, this.state);
        })
    }

    sortByEmail() {
        if (this.state.sortEmail) {
            this.props.users.sort((a, b) => {
                if (a.local.email > b.local.email) return 1;
                if (a.local.email < b.local.email) return -1;

                return 0;
            });
        } else {
            this.props.users.sort((a, b) => {
                if (a.local.email < b.local.email) return 1;
                if (a.local.email > b.local.email) return -1;

                return 0;
            });
        }

        this.setState({sortEmail: !this.state.sortEmail, users: this.props.users, sortType: 'email'});
    }

    sortByEntrance() {
        if (this.state.sortEntrance) {
            this.props.users.sort((a, b) => a.loginCount - b.loginCount);
        } else {
            this.props.users.sort((a, b) => b.loginCount - a.loginCount);
        }

        this.setState({sortEntrance: !this.state.sortEntrance, users: this.props.users, sortType: 'entrance'});
    }

    sortByLastLogin() {
        if (this.state.sortLastLogin) {
            this.props.users.sort((a, b) => {
                if (a.lastLogin > b.lastLogin) return 1;
                if (a.lastLogin < b.lastLogin) return -1;

                return 0;
            });
        } else {
            this.props.users.sort((a, b) => {
                if (a.lastLogin < b.lastLogin) return 1;
                if (a.lastLogin > b.lastLogin) return -1;

                return 0;
            });
        }

        this.setState({sortLastLogin: !this.state.sortLastLogin, users: this.props.users, sortType: 'lastLogin'});
    }

    sortByFreePins() {
        if (this.state.sortFreePins) {
            this.props.users.sort((a, b) => a.pinsCount.free - b.pinsCount.free);
        } else {
            this.props.users.sort((a, b) => b.pinsCount.free - a.pinsCount.free);
        }

        this.setState({sortFreePins: !this.state.sortFreePins, users: this.props.users, sortType: 'freePins'});
    }

    sortByPushPins() {
        if (this.state.sortPushPins) {
            this.props.users.sort((a, b) => a.pinsCount.mid - b.pinsCount.mid);
        } else {
            this.props.users.sort((a, b) => b.pinsCount.mid - a.pinsCount.mid);
        }

        this.setState({sortPushPins: !this.state.sortPushPins, users: this.props.users, sortType: 'pushPins'});
    }

    sortByRulePins() {
        if (this.state.sortRulePins) {
            this.props.users.sort((a, b) => a.pinsCount.high - b.pinsCount.high);
        } else {
            this.props.users.sort((a, b) => b.pinsCount.high - a.pinsCount.high);
        }

        this.setState({sortRulePins: !this.state.sortRulePins, users: this.props.users, sortType: 'rulePins'});
    }

    sortByNickname() {
        if (this.state.sortNickname) {
            this.props.users.sort((a, b) => {
                if (a.nickname > b.nickname) return 1;
                if (a.nickname < b.nickname) return -1;

                return 0;
            });
        } else {
            this.props.users.sort((a, b) => {
                if (a.nickname < b.nickname) return 1;
                if (a.nickname > b.nickname) return -1;

                return 0;
            });
        }

        this.setState({sortNickname: !this.state.sortNickname, users: this.props.users, sortType: 'nickname'});
    }

    handleSaveTempUser() {
        // TODO: check email fields missing
        if (!this.state.tempUserEmail) return alert('Email missing');
        if (!this.state.tempUserPassword) return alert('Password missing');

        // TODO: send save temp user to server
        this.props.createTempUserCall(this.props.token, {
            email: this.state.tempUserEmail.toLowerCase(),
            password: this.state.tempUserPassword,
            nickname: this.state.tempUserNickname
        })
            .then(() => {
                this.setState({ isTempUser: false, ...initialTempUser});
                this.props.getAllUsers(this.props.token, this.state);
            })
            .catch(err => {
                this.setState({ isTimerUser: false, ...initialTempUser});
                console.log('Failed saving temp user', err.response.data);
                if (!err.response || !err.response.data) return

                if (err.response.data.type === 'USER_NO_DATA') {
                    alert('Missing email or/and password');
                    return
                }

                if (err.response.data.type === 'USER_EXIST') {
                    alert('Temp user with this Email already exists. \nTry different email');
                    return
                }

                alert('Failed saving temp user');
            })
    }

    handleAnalyticsClick(userId) {
        this.props.toggleAnalyticsDisable(userId)
    }

    handlePinLimit(userId) {
        this.props.toggleUnlimitedPins(userId);
    }

    renderUsers() {
        if (!this.props.users) return null;

        return this.props.users.map((user) => {
            return (
                <tr key={user._id}>
                    <td className="name">
                        {user.local ? user.local.email : null}
                        {user.facebook ? user.facebook.name : null}
                        {user.google ? user.google.name : null}
                    </td>
                    <td>
                        {user.loginCount}
                    </td>
                    <td>
                        {moment(user.lastLogin).format('DD.MM.YY')}
                    </td>
                    <td>{user.pinsCount ? (user.pinsCount.free || 0) : 0}</td>
                    <td>{user.pinsCount ? (user.pinsCount.mid || 0) : 0}</td>
                    <td>{user.pinsCount ? (user.pinsCount.high || 0) : 0}</td>
                    <td>{user.nickname ? user.nickname : ''}</td>
                    <td>
                        {user.activation.isVerified ? <div className="fa-check"><FaCehck /></div> : <div className="fa-close"><FaClose /></div>}
                    </td>
                    <td>
                        <div onClick={() => this.handleAnalyticsClick(user._id) } className={`clickable-checkmark ${user.isAnalyticsDisabled ? 'fa-close' : 'fa-check'}`}>
                            {user.isAnalyticsDisabled ? <FaClose /> : <FaCehck />}
                        </div>
                    </td>


                    <td className="un-wrapper">
                        <div className={`un-button`}>
                            <ButtonSimple
                                customClass={`un-btn${!user.isUnlimitedPins ? ' normal' : ''}`}
                                label={user.isUnlimitedPins ? 'Unlimited' : 'Normal'}
                                onPress={() => this.handlePinLimit(user._id)}
                            />
                        </div>
                    </td>
                    <td className="buttons-wrapper">
                        <div className="buttons">
                            <div className="be-user-btn">
                                {user.role !== 'admin' ? <ButtonSimple icon={<i><label title="Be this user"><FaBeUser /></label></i>} onPress={() => this.beUserhandler(user)} /> : null}
                            </div>
                            {this.renderActivationButton(user)}
                        </div>
                    </td>
                </tr>
            )
        })
    }

    renderActivationButton(user) {
        if (user.role === 'admin') {
            return (
                <div className="admin">Admin</div>
            )
        }

        if (!user.isActive) {
            return (
                <div className="deactivate">
                    <ButtonSimple label="Deactivated" onPress={() => this.activateUser(user) } />
                </div>
            )
        }

        return (
            <div className="activate">
                <ButtonSimple label="Active" onPress={() => this.deactivateUser(user)} />
            </div>
        )
    }

    renderArrow(direction) {
        if (direction) return <i><FaErrowUp /></i>;
        return <i><FaErrowDown /></i>
    }

    renderTempUser() {
        if (!this.state.isTempUser) return null;

        return (
            <div className="user-temp">
                <thead>
                <tr>
                    <th ><span className="text">User Temp Email</span></th>

                    <th ><span className="text">Password</span></th>
                    <th ><span className="text">Nickname</span></th>
                    <th ><span className="text"></span></th>
                    <th ><span className="text"></span></th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input value={this.state.tempUserEmail} onChange={e => this.setState({ tempUserEmail: e.target.value })} />
                        </td>
                        <td>
                            <input value={this.state.tempUserPassword} onChange={e => this.setState({ tempUserPassword: e.target.value })} />
                        </td>
                        <td>
                            <input value={this.state.tempUserNickname} onChange={e => this.setState({ tempUserNickname: e.target.value })} />
                        </td>
                        <td>
                            <ButtonSimple label={'SAVE'}  onPress={() => this.handleSaveTempUser()}/>
                        </td>
                        <td>
                            <ButtonSimple label={'X'}  onPress={() => this.setState({ isTempUser: false, ...initialTempUser })}/>
                        </td>
                    </tr>
                </tbody>
            </div>
        )
    }

    render() {
        return (
            <div className="admin-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Users</div>
                    </div>
                    <div className="inner-nav">
                        <div className="inner-nav-row">
                            <SimpleDatePicker
                                datePickHandler={(startDate, endDate) => this.dateHandler(startDate, endDate)}
                                label="Dates Range"
                            />

                            {this.state.startDate && this.state.endDate ?
                                <div className="selected-dates">
                                    <span>{moment(this.state.startDate).format('DD.MM.YY')} - {moment(this.state.endDate).format('DD.MM.YY')}</span>
                                </div> : null
                            }


                            <div className="users-btn" onClick={() => this.resetDates()}>Reset Dates</div>
                            <div className={`users-btn ${this.state.isOnlyTmpUsers ? 'selected' : ''}`} onClick={() => this.toggleOnlyTmpUsers()}>Only Temp Users</div>
                            <input type="text" name="user-search" onChange={(event) => this.setUserEmail(event)} placeholder="Search user by email"/>

                            <div className="users-btn" onClick={()=> this.handleSearchClick()}>Search</div>

                            {this.state.isTempUser ? null : <div className="users-btn" onClick={ ()=> this.addTempUser() }>Add Temp User</div>}
                            <div className="users-btn push-right" onClick={ ()=> this.downloadCSV() }>Export</div>

                        </div>
                    </div>


                    <div className="table-wrapper">
                        <div className="table-scroll">
                            {this.props.isMorePages
                                ? <p className="results-label">More results available - narrow search</p>
                                : <p className="results-label">{this.props.users.length} results</p>
                            }
                            {this.renderTempUser()}
                            <table>
                                <thead>
                                <tr>
                                    <th>
                                        <span className="text">User name or email</span>
                                        {this.state.sortType === 'email' ? this.renderArrow(this.state.sortEmail) : null}
                                    </th>
                                    <th>
                                        <span className="text">No Entrance</span>
                                        {this.state.sortType === 'entrance' ? this.renderArrow(this.state.sortEntrance) : null}

                                    </th>
                                    <th>
                                        <span className="text">Last Login</span>
                                        {this.state.sortType === 'lastLogin' ? this.renderArrow(this.state.sortLastLogin) : null}

                                    </th>
                                    <th>
                                        <span className="text">FREE pins</span>
                                        {this.state.sortType === 'freePins' ? this.renderArrow(this.state.sortFreePins) : null}

                                    </th>
                                    <th>
                                        <span className="text">PUSH pins</span>
                                        {this.state.sortType === 'pushPins' ? this.renderArrow(this.state.sortPushPins) : null}

                                    </th>
                                    <th>
                                        <span className="text">RULE pins</span>
                                        {this.state.sortType === 'rulePins' ? this.renderArrow(this.state.sortRulePins) : null}

                                    </th>
                                    <th>
                                        <span className="text">Nickname</span>
                                        {this.state.sortType === 'nickname' ? this.renderArrow(this.state.sortNickname) : null}
                                    </th>
                                    <th>
                                        <span className="text">Verified</span>
                                    </th>
                                    <th>
                                        <span className="text">Analytics</span>
                                    </th>
                                    <th><span className="empty"></span></th>
                                    <th><span className="empty"></span></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderUsers()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AdminUsers.propTypes = {
    users: PropTypes.array,
    token: PropTypes.string,
    getAllUsers: PropTypes.func,
    isMorePages: PropTypes.bool,
    deactivate: PropTypes.func,
    activate: PropTypes.func,
    createTempUserCall: PropTypes.func,
    beUser: PropTypes.func,
    toggleAnalyticsDisable: PropTypes.func,
    toggleUnlimitedPins: PropTypes.func
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    users: state.admin && state.admin.users || [],
    isMorePages: state.admin && state.admin.isMorePages
});

export default connect(mapStateToProps, {
    getAllUsers,
    deactivate,
    activate,
    beUser,
    createTempUserCall,
    toggleAnalyticsDisable,
    toggleUnlimitedPins
})(AdminUsers);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Users/AdminUsers.js